import React, {} from "react"

export default function postSubpopupInfo(res) {
   this.setState(
      {
         subscribe_popup_current_free_trial: res.data.subpopup_info.current_free_trial,
         free_trial_eligible: res.data.subpopup_info.free_trial_eligible,
         subscribe_popup_bronze_price: res.data.subpopup_info.bronze_price,
         subscribe_popup_silver_price: res.data.subpopup_info.silver_price,
         subscribe_popup_gold_price: res.data.subpopup_info.gold_price,
         subscribe_popup_free_perks_text: res.data.subpopup_info.free_perks_text,
         subscribe_popup_bronze_perks_text: res.data.subpopup_info.bronze_perks_text,
         subscribe_popup_silver_perks_text: res.data.subpopup_info.silver_perks_text,
         subscribe_popup_gold_perks_text: res.data.subpopup_info.gold_perks_text,
         subscribe_popup_free_active: res.data.subpopup_info.free_active,
         subscribe_popup_bronze_active: res.data.subpopup_info.bronze_active,
         subscribe_popup_silver_active: res.data.subpopup_info.silver_active,
         subscribe_popup_gold_active: res.data.subpopup_info.gold_active,
         subscribe_popup_free_name: res.data.subpopup_info.free_name,
         subscribe_popup_bronze_name: res.data.subpopup_info.bronze_name,
         subscribe_popup_silver_name: res.data.subpopup_info.silver_name,
         subscribe_popup_gold_name: res.data.subpopup_info.gold_name,
         subscribe_popup_current_duration: res.data.subpopup_info.current_duration,
         subscribe_popup_bronze_annual_price: res.data.subpopup_info.bronze_annual_price,
         subscribe_popup_silver_annual_price: res.data.subpopup_info.silver_annual_price,
         subscribe_popup_gold_annual_price: res.data.subpopup_info.gold_annual_price,
         subscribe_popup_bronze_show_annual_reduction: res.data.subpopup_info.bronze_show_annual_reduction,
         subscribe_popup_silver_show_annual_reduction: res.data.subpopup_info.silver_show_annual_reduction,
         subscribe_popup_gold_show_annual_reduction: res.data.subpopup_info.gold_show_annual_reduction,
         subscribe_popup_bronze_monthly_active: res.data.subpopup_info.bronze_monthly_active,
         subscribe_popup_silver_monthly_active: res.data.subpopup_info.silver_monthly_active,
         subscribe_popup_gold_monthly_active: res.data.subpopup_info.gold_monthly_active,
         subscribe_popup_bronze_annual_active: res.data.subpopup_info.bronze_annual_active,
         subscribe_popup_silver_annual_active: res.data.subpopup_info.silver_annual_active,
         subscribe_popup_gold_annual_active: res.data.subpopup_info.gold_annual_active,
         subscribe_popup_trial_length: res.data.subpopup_info.trial_length,
         subscribe_popup_async_price: res.data.subpopup_info.async_price,
         subscribe_popup_async_perks_text: res.data.subpopup_info.async_perks_text,
         subscribe_popup_async_active: res.data.subpopup_info.async_active,
         subscribe_popup_async_name: res.data.subpopup_info.async_name,
         subscribe_popup_async_annual_price: res.data.subpopup_info.async_annual_price,
         subscribe_popup_async_show_annual_reduction: res.data.subpopup_info.async_show_annual_reduction,
         subscribe_popup_async_monthly_active: res.data.subpopup_info.async_monthly_active,
         subscribe_popup_async_annual_active: res.data.subpopup_info.async_annual_active,
         subscribe_popup_current_tier: res.data.subpopup_info.current_tier,
         subscribe_popup_async_tier_access: res.data.subpopup_info.async_tier_access,
         subscribe_popup_async_annual_duration: res.data.subpopup_info.async_annual_duration,
         subscribe_popup_async_annual_duration_type: res.data.subpopup_info.async_annual_duration_type,
         subscribe_popup_async_annual_rebill: res.data.subpopup_info.async_annual_rebill,
         subscribe_popup_async_tier_apply: res.data.subpopup_info.async_tier_apply,
         async_apply: res.data.subpopup_info.async_apply,   
         gold_access: res.data.subpopup_info.gold_access,
         silver_access: res.data.subpopup_info.silver_access,   
      }
   )
}
